import React from 'react';
import { Dialog, DialogTitle, IconButton, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FocusCentral from 'careiq/ui/focusCentral';

const FollowupShareModal = ({ open, onClose, patient_insights }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md" // You can change to 'md' or 'xl' as needed
      PaperProps={{ style: { backgroundColor: '#f9fafb', borderRadius: '8px' } }}
    >
      <div className="p-4 flex justify-between items-center bg-white border-b">
        <h2 className="text-xl font-semibold text-blue-800">Follow-up Share View</h2>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <DialogContent dividers className="p-4">
        <div className="max-w-6xl mx-auto">
          {/* Render FocusCentral in expanded view mode */}
          <FocusCentral view={1} patient_insights={patient_insights} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FollowupShareModal;
